import styles from './RouteLoadingFallback.module.css';

/**
 * Shown while a lazy route chunk is loading (e.g. after navigation).
 * @param {{ t: (key: string) => string }} props
 */
export function RouteLoadingFallback({ t }) {
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <p className={styles.pulse}>{t('systemSettingsLoading')}</p>
    </div>
  );
}
